import RouteEnum from "constants/RouteEnum";
import IStore from "models/IStore";
import NotificationModel from "models/api-models/NotificationModel";
import React, { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Dispatch } from "redux";
import * as AuthAction from "stores/auth/AuthAction";
import OutsideClickHandler from "views/components/outside-click-handler/OutsideClickHandler";

const NotificationIcon: React.FC = () => {
  const dispatch: Dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [show, setShow] = React.useState<boolean>(false);

  const unSeennotifications = useSelector((state: IStore) => state.auth.unSeennotifications);

  const renderDate = (date: string) => {
    const dateObj = new Date(date);
    return dateObj.toLocaleDateString();
  };

  const handleMarkAsRead = (notification: NotificationModel) => {
    if (notification.url && notification.profile_type) {
      // eslint-disable-next-line security/detect-unsafe-regex
      const url = notification.url.replace(/^(?:\/\/|[^/]+)*\//, "");
      dispatch(AuthAction.setSelectedProfile(notification.profile_type));
      if (notification.seen === false) {
        dispatch(AuthAction.requestSeenNotification(notification.uuid));
      }
      setTimeout(() => {
        navigate(url);
      }, 100);
    }
  };

  const handleOutsideClick = () => {
    setShow(false);
  };

  const handleButtonClick = () => {
    setShow(!show);
  };

  useEffect(() => {
    dispatch(AuthAction.requestUnseenNotifications());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const lastNotifications = useMemo(() => {
    const results = unSeennotifications?.results || []; // results dizisini alın veya boş bir dizi kullanın
    const limitedResults = results.slice(0, 3); // İlk üç öğeyi alın
    return limitedResults.map((item) => ({ ...item }) as NotificationModel); // Her öğeyi kopyalayarak yeni bir dizi oluşturun
  }, [unSeennotifications]);

  const renderEmpty = () => {
    return (
      <div className="item-body">
        <div className="media">
          <div className="media-body">
            <h6 className="item-title">{t("notification-page.no-notification")}</h6>
          </div>
        </div>
      </div>
    );
  };

  const handleMarkAllAsRead = () => {
    dispatch(AuthAction.requestSeenAllNotification());
  };

  return (
    <div id="notification-icon" className={`inline-item d-flex align-items-center ${show ? "show" : ""}`}>
      <div className="dropdown dropdown-notification">
        <button
          className="dropdown-toggle"
          type="button"
          onClick={handleButtonClick}
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="icofont icofont-notification"></i>
          <span className="notify-count">{unSeennotifications?.count}</span>
        </button>
        {show && (
          <OutsideClickHandler isOpen={show} onOutsideClick={handleOutsideClick}>
            <div id="notification-dropdown" ref={wrapperRef} className="dropdown-menu dropdown-menu-right show">
              <div className="item-heading">
                <h6 className="heading-title">{t("notification-page.title")}</h6>
                <div className="heading-btn">
                  <Link to="#" onClick={handleMarkAllAsRead}>
                    {t("notification-page.mark-all-as-read")}
                  </Link>
                </div>
              </div>
              {unSeennotifications?.count === 0
                ? renderEmpty()
                : lastNotifications.map((notification: NotificationModel) => (
                    <div key={notification.uuid} className="item-body">
                      <Link
                        to=""
                        className="media"
                        onClick={() => {
                          handleMarkAsRead(notification);
                        }}
                      >
                        <div className="media-body">
                          <h6 className="item-title">{notification.content?.title || t("undefined")}</h6>
                          <p>
                            {notification.content?.message && notification.content?.message.substring(0, 100) + "..."}
                          </p>
                          <div className="item-time">{renderDate(notification.created_at)}</div>
                        </div>
                      </Link>
                    </div>
                  ))}
              <div className="item-footer">
                <Link to={RouteEnum.Notifications} className="view-btn">
                  {t("notification-page.view-all-notification")}
                </Link>
              </div>
            </div>
          </OutsideClickHandler>
        )}
      </div>
    </div>
  );
};

export default NotificationIcon;
